// extracted by mini-css-extract-plugin
module.exports = {"button":"button__2shQF","accepted":"accepted__hc2oM","container":"container__38DMp"};